import styled, { css } from 'styled-components'

import { ContainerProps } from '@customTypes'
import { mediaQueries } from '_styles/variables'

export const Container: React.FC<ContainerProps> = styled.div<ContainerProps>`
  width: 100%;
  margin: 0 auto;
  padding: 0;

  ${({ responsive }) =>
    responsive &&
    css`
      @media ${mediaQueries.desktop} {
        max-width: 76.25rem;
      }

      @media ${mediaQueries.ipadPro} {
        max-width: 59.25rem;
      }
    `}
`
